import React from 'react'
import PropTypes from 'prop-types'
import { updateObject } from 'helpers/objectHelpers'
import withDevicesForm from 'hocs/extends/withDevicesForm'
import { elementStyleStructure } from 'components/Canvas/renderer/utils/styleStructureUtils'
import { elementTabsStyle } from 'components/Canvas/renderer/utils/styleTabUtils'
import Tabs from 'components/Tabs/Tabs'
import BorderForm from 'components/forms/BorderForm'
import Accordion from 'components/accordions/Accordion'
import LayoutForm from 'components/forms/LayoutForm'
import TypoForm from 'components/forms/TypoForm'
import ThemeForm from 'components/forms/ThemeForm'

const DefaultStyles = ({
  valueStyles,
  valueStyles: {
    layout = {},
    border = {},
    typography = {},
  },
  onChangeStyles,
  onRerender,
  refElement,
  valueSettings,
  onChangeSettings,
  valueContent = {},
  onChangeContent,
}) => {
  const handleUpdateStyle = (val, key) => {
    return onChangeStyles(updateObject(valueStyles, { [key]: val }))
  }

  const tabs = elementTabsStyle[refElement]
  const styleStructure = elementStyleStructure[refElement]
  const renderStyleForm = (tab) => {
    switch (tab.tabValue) {
      case 'layout' :
        return (
          <LayoutForm
            {...tab}
            key={tab.tabValue}
            onRerender={onRerender}
            label="Layout"
            subValue="layout"
            value={layout}
            onChange={(val) => handleUpdateStyle(val, 'layout')}
            styleStructure={styleStructure}
            valueContent={valueContent}
            onChangeContent={onChangeContent}
          />
        )
      case 'border' :
        return (
          <BorderForm
            {...tab}
            key={tab.tabValue}
            label="Border"
            subValue="border"
            value={border}
            onChange={(val) => handleUpdateStyle(val, 'border')}
          />
        )
      case 'typography' :
        return (
          <TypoForm
            {...tab}
            key={tab.tabValue}
            onRerender={onRerender}
            label="Typography"
            subValue="typography"
            value={typography}
            onChange={(val) => handleUpdateStyle(val, 'typography')}
            styleStructure={styleStructure}
            valueSettings={valueSettings}
            onChangeSettings={onChangeSettings}
          />
        )
      case 'theme' :
        return (
          <ThemeForm
            {...tab}
            key={tab.tabValue}
            valueSettings={valueSettings}
            onChangeSettings={onChangeSettings}
          />
        )
      default:
        return null
    }
  }
  if (tabs.length === 1) {
    return renderStyleForm(tabs[0])
  }

  return (
    <Tabs.D
      style={{ maxWidth: 400, margin: 'auto' }}
      onTouchTab={onRerender}
      length={tabs.length}
    >
      {tabs.map((tab) => renderStyleForm(tab))}
    </Tabs.D>
  )
}

const DevicesStyles = withDevicesForm(DefaultStyles)

const StylesSwitcher = ({
  value,
  value: {
    defaultStyles = {},
    deviceStyles = {},
    defaultSettings = {},
    deviceSettings = {},
    defaultContent = {},
    deviceContent = {},
  },
  onChange,
  refElement,
}) => {
  const handleUpdate = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <Accordion
      accordionProps={{ isLargePadded: true }}
      defaultActiveItems={['default']}
    >
      <DefaultStyles
        label="Default styles"
        subValue="default"
        valueStyles={defaultStyles}
        onChangeStyles={(val) => handleUpdate(val, 'defaultStyles')}
        refElement={refElement}
        valueSettings={defaultSettings}
        onChangeSettings={(val) => handleUpdate(val, 'defaultSettings')}
        valueContent={defaultContent}
        onChangeContent={(val) => handleUpdate(val, 'defaultContent')}
      />
      <DevicesStyles
        label="Override in each device"
        subValue="device"
        valueStyles={deviceStyles}
        onChangeStyles={(val) => handleUpdate(val, 'deviceStyles')}
        valueSettings={deviceSettings}
        refElement={refElement}
        onChangeSettings={(val) => handleUpdate(val, 'deviceSettings')}
        valueContent={deviceContent}
        onChangeContent={(val) => handleUpdate(val, 'deviceContent')}
      />
    </Accordion>
  )
}

StylesSwitcher.propTypes = {}
StylesSwitcher.defaultProps = {}

export default StylesSwitcher



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/panel/StylesSwitcher.js